export default __webpack_public_path__ + "static/media/Logo.939b80ba.svg";